import { useMutation, useQueryClient } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";

/**
 * Sprint 21 — supervisor actions on pattern memories: adjust confidence (boost /
 * reduce / "not a pattern") and trigger pattern detection. Both refresh the
 * memory lists so the chrome reflects the new confidence / new pattern memories.
 */

export interface AdjustConfidenceResult {
  memory_id: string;
  previous_confidence: number;
  confidence: number;
}

export function useAdjustMemoryConfidence() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ memory_id, delta, reason }: { memory_id: string; delta: number; reason?: string }) => {
      const r = await mcpClient.toolsCall<{ result?: AdjustConfidenceResult }>("adjust_memory_confidence", {
        memory_id,
        delta,
        ...(reason ? { reason } : {}),
      });
      if (r.isError) throw new Error(r.content?.[0]?.text ?? "Adjust failed");
      return r.structuredContent?.result;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["child-nodes"] }),
  });
}

export function useFindPatterns() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ agent_id }: { agent_id?: string } = {}) => {
      const r = await mcpClient.toolsCall("find_patterns", agent_id ? { agent_id } : {});
      if (r.isError) throw new Error(r.content?.[0]?.text ?? "Pattern detection failed");
      return r.structuredContent;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["child-nodes"] }),
  });
}
